import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import PrimaryButton from "../../../Components/Buttons/primary-button";

import renderStakeCheckingPending from "./stake-checking-pending";

import { useModalContext } from "../../../Contexts/ModalContext";

import { useStakeDebit } from "../../../CustomHooks/Queries";

import { isSVDPending } from "../../../Utils/helpers";
import { modalVariants } from "../../../Utils/constants";

import { StakeCardFrontSide } from "../../../Assets/Images";
import { CircleExclamationOutlined } from "../../../Assets/Icons";

export default function renderStakeCheckingVerificationPending(modalContext, unitTabRef) {
  const {
    updateModalComponent,
    pushModalStack,
    setModalVariant,
    setModalPromoComponent,
    setModalTitle,
    setModalClassName,
  } = modalContext;

  updateModalComponent(() => <StakeCheckingVerificationPending unitTabRef={unitTabRef} />);
  pushModalStack(() => renderStakeCheckingVerificationPending(modalContext));
  setModalPromoComponent(null);
  setModalTitle("");
  setModalClassName("hide-header no-full-screen");
  setModalVariant(modalVariants.flexDialog);
}

const StakeCheckingVerificationPending = ({ unitTabRef }) => {
  const SVDApplicationSession = useRef(unitTabRef);

  const modalContext = useModalContext();
  const { modalStack, setModalStack, popModalStack, onModalClose } = modalContext;

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { data: stakeDebit } = useStakeDebit({ refetchInterval: 3 * 1000, refetchIntervalInBackground: true });

  useEffect(() => {
    if (isSVDPending(stakeDebit?.data)) {
      if (!SVDApplicationSession?.current?.closed) {
        SVDApplicationSession?.current?.close();
      }
      setModalStack((p) => p.slice(0, modalStack.length - 1));
      renderStakeCheckingPending(modalContext);
    } //eslint-disable-next-line
  }, [stakeDebit?.data]);

  const openUnitOnNewTab = () => {
    if (stakeDebit?.data?.data?.is_synctera_user) {
      navigate("/verify-stake-checking", { state: { previousPathname: pathname } });
      onModalClose();
    } else {
      const newWindow = window.open(stakeDebit?.data?.data?.application_link ?? "", "_blank");
      SVDApplicationSession.current = newWindow;
    }
  };

  return (
    <>
      <div className="modal-dialog-content mt-6">
        <img className="stake-card-front-side" src={StakeCardFrontSide} alt="" />
        <h3 className="modal-status-title mt-6 mb-5">
          Your Stake checking application requires additional verification.
        </h3>
        <div className="info-alert positive">
          <CircleExclamationOutlined />
          <div>
            Almost there
            <div className="text-xs-regular mt-1">
              To finish setting up your Stake Checking and start earning Cash Back, we just need a few more details to
              verify your identity.
            </div>
          </div>
        </div>
      </div>
      <div className="action-container">
        <PrimaryButton onClick={openUnitOnNewTab}>Start Verification</PrimaryButton>
        <PrimaryButton className="secondary-colors" onClick={() => popModalStack(1)}>
          Later
        </PrimaryButton>
      </div>
    </>
  );
};
